import { useAutoAnimate } from '@formkit/auto-animate/react'

import { ddmmyyyy, hhmm } from '../../config/functions'
import {
    getDefaultReportTimes,
    hhmmFromTimeEntry,
    normalizeReportTimes,
    updateTimeEntryAtIndex,
    withReportTimes,
} from '../../config/reportTime'

// import useChecklist from '../../hooks/useChecklist'
import useAuth from '../../hooks/useAuth'

import FormField from '../../components/FormField'
import { reportFrequency } from '../../config/constants'
import { useEffect } from 'react'
import { useMemo } from 'react'
import { use } from 'react'
export default function AlertSetup({ data, setData }) {
    const { isCompany, user } = useAuth();
    const company = isCompany ? user : data?.companyID;
    const [reportFieldAnimation] = useAutoAnimate();
    const days = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday']
    // .filter(day => !company ? true : company?.schedule?.includes(day))
    const alertTimes = useMemo(
        () => normalizeReportTimes(data.reportFrequency?.times?.length ? data.reportFrequency.times : getDefaultReportTimes()),
        [data.reportFrequency?.times]
    )
    const setAlertTimes = (alertTimes) => {
        setData({
            ...data,
            reportFrequency: withReportTimes(data.reportFrequency, alertTimes),
        })
    }
    const reportFrequencyFields = useMemo(() => {
        return alertTimes?.map((time, index) => ({
            value: hhmmFromTimeEntry(time),
            setValue: (value) => {
                setAlertTimes(updateTimeEntryAtIndex(alertTimes, index, value))
            },
            type: 'time',
            id: `alertTime${index}`,
            placeholder: 'Select alert time',
            // min: hhmm(company?.workStartTime),
            // max: hhmm(company?.workEndTime),
        }))
    }, [data.reportFrequency?.times])
    const checklistReportFields = [
        {
            value: data?.riskAssesmentReport,
            setValue: (value) => {
                console.log(value)
                setData({ ...data, riskAssesmentReport: value })
                console.log(data)
            },
            type: 'radio',
            options: ['None', ...reportFrequency]
        },
        data?.riskAssesmentReport != 'Weekly' ? null : {
            placeholder: 'Select Day',
            value: data?.reportFrequency?.day,
            type: 'dropdown',
            options: days,
            setValue: (value) => {
                setData({
                    ...data,
                    reportFrequency: { ...data.reportFrequency, day: value }
                })
            },
        },
        data?.riskAssesmentReport != 'Monthly' ? null : {
            placeholder: 'Select Day',
            value: data?.reportFrequency?.day,
            type: 'dropdown',
            options: [...new Array(31)].map((item, index) => `${index + 1}`),
            setValue: (value) => {
                setData({
                    ...data,
                    reportFrequency: { ...data.reportFrequency, day: value }
                })
            },
        },
        data?.riskAssesmentReport != 'Annual' ? null : {
            value: ddmmyyyy(data?.reportFrequency?.date),
            setValue: (value) => {
                const date = new Date(value)
                setData({ ...data, reportFrequency: { ...data.reportFrequency, date: date.getTime() } })
            },
            type: 'date',
            id: 'checklistFreq',
            placeholder: 'Select frequency date'
        },
    ].filter(item => item)
    useEffect(() => {
        if (!data.riskAssesmentReport) {
            setData({ ...data, riskAssesmentReport: 'None' })
        }
        if (data.reportFrequency?.times?.length < 1 || !data.reportFrequency?.times) {
            setData({
                ...data,
                reportFrequency: withReportTimes(data.reportFrequency, getDefaultReportTimes())
            })
        }
        if (!data.reportFrequency?.date) {
            setData({
                ...data,
                reportFrequency: { ...data.reportFrequency, date: Date.now() }
            })
        }

    }, [])
    return (
        <div className="col-md-12 col-12">
            <div className="card">
                <div className="card-body">
                    <h5 className="card-title">Select Risk Assessment Report</h5>
                    {
                        checklistReportFields?.map((item, index) => (
                            <FormField item={item} key={`alert-${index}`} uniqueId={`alert-${index}-`} />
                        ))
                    }
                    {
                        data.riskAssesmentReport == 'Daily' && <div className="form-check mb-4">
                            <input
                                className="form-check-input"
                                type="checkbox"
                                name="gridRadios"
                                id="gridRadios1"
                                value={"everyday"}
                                checked={data?.reportFrequency?.everyday}
                                onChange={(e) => {
                                    setData({
                                        ...data,
                                        reportFrequency: { ...data.reportFrequency, everyday: e.target.checked }
                                    })
                                }}
                            />
                            <label className="form-check-label" htmlFor="gridRadios1">
                                Select this if you want to recieve report everyday including non-operational days.
                            </label>
                        </div>
                    }
                    {
                        data?.riskAssesmentReport == 'None' ? null :
                            <div className="col-md-12 col-12 mt-2">
                                <div className="card">
                                    <div className="card-body">
                                        <div className='d-flex align-items-center justify-content-between'>
                                            <h5 className="card-title">Set Report Time</h5>
                                        </div>
                                        <div className='d-flex flex-column gap-3'>
                                            <ul ref={reportFieldAnimation} className='ps-0'>
                                                {
                                                    reportFrequencyFields?.map((item, index) => (
                                                        <li className='d-flex gap-3 mb-3 align-items-center' key={index}>
                                                            <FormField item={item} />
                                                            {
                                                                index == 0 ? null :
                                                                    <i
                                                                        onClick={() => setAlertTimes(alertTimes?.filter((it, i) => index != i))}
                                                                        className="bi bi-trash3 text-danger"
                                                                        style={{ cursor: 'pointer' }}
                                                                    />
                                                            }
                                                        </li>
                                                    ))
                                                }
                                            </ul>

                                        </div>
                                    </div>
                                </div>
                            </div>
                    }
                </div>
            </div>
        </div>
    )
}
